// extracted by mini-css-extract-plugin
module.exports = {"warningContainer":"MultiPurposeInfo_warningContainer__2Np_9","warningMessage":"MultiPurposeInfo_warningMessage__2gI-2","icon":"MultiPurposeInfo_icon__3p-Ev"};